import { addScanFromScanner } from "actions";

import {
  DeviceLike,
  getDeviceId,
} from "lib/deviceDrivers/sessionFramework/runtime/DriverSession";
import { parseBinaryAgFrame } from "lib/deviceDrivers/gallagher/binaryAg";
import { formatEid } from "lib/eid/iso11784";
import toast from "lib/toast";
export const GALLAGHER_BLE_HR0_DRIVER_NAME = "gallagher-hr0-ble";
export const GALLAGHER_BLE_HR0_CAPABILITIES = [];

export type DriverAction = ReturnType<typeof addScanFromScanner>;

export type DriverActionResult = DriverAction[];

/**
 * Decodes a BinaryAg-framed scan payload from a Gallagher HR0 BLE reader into a scan action.
 * The reader has no concept of message types, so this is the single handler for every message
 * it sends. Malformed or unparseable payloads are reported to the operator via a toast and
 * swallowed (returning no actions) rather than throwing, since a single bad scan should not
 * take down the driver session.
 */
export const bleHr0ProcessMessage = (
  device: DeviceLike,
  _type: string,
  _status: unknown,
  serializedPayload: string,
): DriverActionResult => {
  try {
    const frame = parseBinaryAgFrame(serializedPayload);

    const scan = {
      created: new Date().toISOString(),
      EID: formatEid(frame.tagData),
      draftName: "",
    };

    return [addScanFromScanner(getDeviceId(device), scan)];
  } catch (error) {
    toast.error("Received invalid EID data from scanner");

    // eslint-disable-next-line no-console
    console.warn(error);
    return [];
  }
};
